import {
  Badge,
  Button,
  Modal,
  PageHeader,
  Table,
  Input,
  Popover,
  Menu,
  Checkbox,
  Select,
  Card
} from 'antd'
import moment from 'moment'
import 'moment-timezone'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { token } from '../../config'
import { apiClient } from '../../api'
import { SearchOutlined } from '@ant-design/icons'

const { Option } = Select
moment.tz.setDefault('Asia/Bangkok')

const routes = [
  {
    path: '/permission',
    breadcrumbName: 'User Permission'
  }
]
function Permission() {
  const [selectKey, setSelectKey] = useState(new Date().toString())
  const [datas, setDatas] = useState()
  const [modalCreate, setModalCreate] = useState(false)
  const [modalEdit, setModalEdit] = useState(false)
  const [l1, setL1] = useState([])
  const [selected, setSelected] = useState(null)
  const [search, setSearch] = useState('')

  const checkChange = (event, func) => {
    const { name, checked } = event.target
    func(prev => ({
      ...prev,
      [name]: checked
    }))
  }
  const load = () => {
    apiClient
      .post(
        'api/Announcement/Get',
        {
          Path: 'permission'
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
          }
        }
      )
      .then(result => {
        setDatas(result.data)
        if (search) {
          const dt = result.data
          setDatas(
            dt.filter(
              x =>
                x.Username.toLowerCase().includes(search.toLowerCase()) ||
                x.AccountParentName.toLowerCase().includes(search.toLowerCase())
            )
          )
        }
      })
    if (search === '') {
      apiClient
        .post(
          'api/Announcement/Get',
          {
            Path: 'account/level1'
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-type': 'application/json; charset=UTF-8'
            }
          }
        )
        .then(result => {
          setL1(result.data)
        })
    }
  }

  const editClick = id => {
    apiClient
      .post(
        '/api/Announcement/Permission/ListByID',
        {
          uid: id.toString()
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
          }
        }
      )
      .then(result => {
        setModalEdit({ ...result.data, UsernameId: id })
      })
  }

  const createClick = () => {
    apiClient
      .post(
        '/api/Announcement/Permission/Create',
        {
          UsernameId: modalCreate.UsernameId,
          IsBanner: modalCreate.IsBanner,
          IsNews: modalCreate.IsNews
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
          }
        }
      )
      .then(result => {
        document.getElementById('ModalCreateCancle').click()
        if (result.data === 'create permission succcessfully') {
          Modal.success({
            title: 'Success',
            content: 'Created',
            okText: 'OK',
            icon: <i className="fa-solid fa-circle-check text-success"></i>,
            onOk() {
              load()
              setSelected(null)
              setSelectKey(new Date().toString())
              setModalCreate({})
            }
          })
        } else {
          Modal.error({
            title: result?.data?.detail || 'Fail',
            content: '',
            okText: 'OK',
            icon: <i className="fa-solid fa-circle-xmark text-danger"></i>
          })
        }
      })
  }

  const updateClick = () => {
    apiClient
      .post(
        `/api/Announcement/Permission/Update/${modalEdit.Id}`,
        {
          IsBanner: modalEdit.IsBanner,
          IsNews: modalEdit.IsNews
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
          }
        }
      )
      .then(result => {
        document.getElementById('ModalEditCancle').click()
        if (result.data === 'update permission succcessfully') {
          Modal.success({
            title: 'Success',
            content: 'Updated',
            okText: 'OK',
            icon: <i className="fa-solid fa-circle-check text-success"></i>,
            onOk() {
              load()
            }
          })
        } else {
          Modal.error({
            title: result?.data?.detail || 'Fail',
            content: '',
            okText: 'OK',
            icon: <i className="fa-solid fa-circle-xmark text-danger"></i>
          })
        }
      })
  }

  const deleteClick = (id, text) => {
    Modal.confirm({
      title: 'Delete News',
      content: text,
      okText: 'Delete',
      cancelText: 'Cancel',
      icon: <i className="fa-solid fa-circle-exclamation text-danger"></i>,
      onOk() {
        apiClient
          .post(
            '/api/Announcement/Permission/DeleteByID',
            {
              uid: id.toString()
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/json; charset=UTF-8'
              }
            }
          )
          .then(result => {
            if (result.data === 'delete permission succcessfully') {
              Modal.success({
                title: 'Success',
                content: 'Deleted',
                okText: 'OK',
                icon: <i className="fa-solid fa-circle-check text-success"></i>,
                onOk() {
                  load()
                }
              })
            } else {
              Modal.error({
                title: result?.data?.detail || 'Fail',
                content: '',
                okText: 'OK',
                icon: <i className="fa-solid fa-circle-xmark text-danger"></i>
              })
            }
          })
      },
      okButtonProps: {
        style: { margin: '0px 1rem' }
      },
      cancelButtonProps: {
        style: { margin: '0px 1rem' }
      }
    })
  }

  const loadDetail = id => {
    apiClient
      .post(
        'api/Announcement/Get',
        {
          Path: `account/level1/${id}`
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json; charset=UTF-8'
          }
        }
      )
      .then(result => {
        setModalCreate({
          AccountParentName: result.data?.AccName || '',
          AccLevel: result.data?.AccLevel || '',
          AccTotalChild: result.data?.AccTotalChild || '',
          UsrID: result.data?.UsrID || '',
          UsernameId: id,
          UsrUsername: result.data?.UsrUsername || ''
        })
      })
  }

  const columns = [
    Object.assign(
      {
        title: 'Account Name',
        dataIndex: 'AccountParentName',
        key: 'AccountParentName',
        width: '30%'
      },
      { render: text => text },
      {
        sorter: (a, b) => {
          const nameA = a?.AccountParentName || ''
          const nameB = b?.AccountParentName || ''
          return nameA.localeCompare(nameB)
        },
        sortDirections: ['descend', 'ascend']
      }
    ),
    Object.assign(
      { title: 'Username', dataIndex: 'Username', key: 'Username', width: '30%' },
      { render: text => text },
      {
        sorter: (a, b) => {
          const nameA = a?.Username || ''
          const nameB = b?.Username || ''
          return nameA.localeCompare(nameB)
        },
        sortDirections: ['descend', 'ascend']
      }
    ),
    Object.assign(
      { title: 'News', dataIndex: 'IsBanner', key: 'IsBanner', width: '20%' },
      {
        render: text => (
          <i className={`fa-solid ${text ? 'fa-check text-success' : 'fa-x text-danger'}`}></i>
        )
      },
      {
        sorter: (a, b) => (a.IsBanner ? 1 : 2) - (b.IsBanner ? 1 : 2),
        sortDirections: ['descend', 'ascend']
      }
    ),
    Object.assign(
      { title: 'Announcement', dataIndex: 'IsNews', key: 'IsNews', width: '20%' },
      {
        render: text => (
          <i className={`fa-solid ${text ? 'fa-check text-success' : 'fa-x text-danger'}`}></i>
        )
      },
      {
        sorter: (a, b) => (a.IsNews ? 1 : 2) - (b.IsNews ? 1 : 2),
        sortDirections: ['descend', 'ascend']
      }
    ),
    {
      dataIndex: 'key',
      key: 'key',
      width: 50,
      align: 'right',
      render: (key, item) => (
        <div>
          <Popover
            placement="bottomRight"
            content={
              <Menu mode="vertical">
                <Menu.Item
                  key="2"
                  style={{ borderBottom: '1px solid #7b7b7b' }}
                  onClick={() => editClick(item.UsernameId)}
                  data-toggle="modal"
                  data-target="#ModalEdit"
                >
                  <span className="fa fa-pencil-square-o ants-gray size14"></span>&nbsp;&nbsp; Edit
                </Menu.Item>

                <Menu.Item key="3" onClick={() => deleteClick(item.Id, item.Username)}>
                  <span className="fa fa-trash-o ants-gray size14"></span>&nbsp;&nbsp; Delete
                </Menu.Item>
              </Menu>
            }
            trigger="click"
          >
            <span
              className="fa fa-ellipsis-v"
              style={{ cursor: 'pointer', width: 30, textAlign: 'center' }}
            ></span>
          </Popover>
        </div>
      )
    }
  ]

  useEffect(() => {
    load()
  }, [])
  return (
    <div className="animated fadeIn">
      <PageHeader breadcrumb={{ routes }}>
        <Row gutter={8} type="flex" justify="end">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                style={{ marginRight: 8 }}
                data-toggle="modal"
                data-target="#ModalCreate"
              >
                <span className="fa fa-plus-circle"></span> &nbsp;&nbsp; New
              </Button>
            </div>
          </Col>
        </Row>
      </PageHeader>
      <div className="content">
        <Card>
          {/* modal edit */}
          <div
            className="modal fade"
            id="ModalEdit"
            tabindex="-1"
            role="dialog"
            aria-labelledby="ModalEditTitle"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="d-flex justify-content-center m-3">
                  <h5>Acount ID #{modalEdit?.UsernameId || ''}</h5>
                </div>
                <div className="modal-body">
                  <p>Account Name : {modalEdit?.AccountParentName}</p>
                  <p>Acc Level : {modalEdit?.AccDetail?.AccLevel}</p>
                  <p>Username : {modalEdit?.Username}</p>
                  <p>จำนวน Account ที่อยู่ภายใต้ : {modalEdit?.AccDetail?.AccTotalChild}</p>
                  <hr />
                  <Checkbox
                    name="IsBanner"
                    onChange={event => checkChange(event, setModalEdit)}
                    checked={modalEdit?.IsBanner}
                  >
                    News
                  </Checkbox>
                  <Checkbox
                    name="IsNews"
                    onChange={event => checkChange(event, setModalEdit)}
                    checked={modalEdit?.IsNews}
                  >
                    Announcement
                  </Checkbox>
                </div>
                <div className="modal-footer d-flex justify-content-center">
                  <Button id="ModalEditCancle" data-dismiss="modal" aria-label="Close">
                    Cancel
                  </Button>
                  <Button type="primary" onClick={updateClick}>
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </div>
          {/* modal create */}
          <div
            className="modal fade"
            id="ModalCreate"
            tabindex="-1"
            role="dialog"
            aria-labelledby="ModalCreateTitle"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="d-flex justify-content-center m-3">
                  <Select
                    key={selectKey}
                    id="selectUsername"
                    showSearch
                    placeholder="Search Username(Account Name)"
                    style={{
                      width: '100%'
                    }}
                  >
                    {l1?.map((x, index) => (
                      <Option
                        key={index}
                        value={`${x.UsrUsername}(${x.AccName})`}
                        onClick={() => {
                          loadDetail(x.UsrID)
                          setModalCreate(prev => ({
                            ...prev,
                            UsernameId: x.UsrID,
                            AccountParentName: x.AccName
                          }))
                          setSelected(`${x.UsrUsername}(${x.AccName})`)
                        }}
                      >
                        {x.UsrUsername}({x.AccName})
                      </Option>
                    ))}
                  </Select>
                </div>
                <div className="modal-body">
                  <p>Account Name : {modalCreate?.AccountParentName}</p>
                  <p>AccLevel : {modalCreate?.AccLevel}</p>
                  <p>จำนวน Account ที่อยู่ภายใต้ : {modalCreate?.AccTotalChild}</p>
                  <hr />
                  <Checkbox
                    name="IsBanner"
                    onChange={event => checkChange(event, setModalCreate)}
                    checked={modalCreate?.IsBanner}
                  >
                    News
                  </Checkbox>
                  <Checkbox
                    name="IsNews"
                    onChange={event => checkChange(event, setModalCreate)}
                    checked={modalCreate?.IsNews}
                  >
                    Announcement
                  </Checkbox>
                </div>
                <div className="modal-footer d-flex justify-content-center">
                  <Button id="ModalCreateCancle" data-dismiss="modal" aria-label="Close">
                    Cancel
                  </Button>
                  <Button type="primary" onClick={createClick}>
                    Create
                  </Button>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-4">
              <Input placeholder="Search" onChange={event => setSearch(event.target.value)} />
            </div>
            <div className="col-8">
              <Button onClick={load}>
                <SearchOutlined /> Search
              </Button>
            </div>
          </div>
          <Table
            columns={columns}
            dataSource={datas}
            pagination={{
              defaultPageSize: 10,
              pageSizeOptions: ['10', '20', '50', '100'],
              showSizeChanger: true,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
            }}
          />
        </Card>
      </div>
    </div>
  )
}

export default Permission